import Swal from "sweetalert2";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { AppState } from "src/app/store/index.selector";
import { toggleAnimation } from "src/app/shared/animations";
import { UserRoles } from "src/app/shared/enums/user-roles";
import { MessagePortalComponent } from "src/app/portal/portal";
import { CustomerType } from "src/app/shared/types/contract-types";
import { TableService } from "src/app/shared/services/table.service";
import { ContractService } from "src/app/shared/services/contract.service";
import { PositioningService } from "src/app/shared/services/positioning.service";
import { ChangeDetectorRef, Component, ElementRef, ViewChild } from "@angular/core";
import { BaseTableComponent, DatatableColumn } from "src/app/shared/components/base-table/base-table.component";
import { showMessage } from "src/app/shared/utils/toast.popup";
import { PopupType } from "src/app/shared/enums/popup-types";

@Component({
  templateUrl: "./customers-table.component.html",
  standalone: false,
  animations: [toggleAnimation],
})
export class CustomersTableComponent extends BaseTableComponent<CustomerType> {
  constructor(
    private fb: FormBuilder,
    public override translate: TranslateService,
    public override store: Store<AppState>,
    public override tableService: TableService,
    private contractService: ContractService,
    private positioningService: PositioningService,
    private cdRef: ChangeDetectorRef,
  ) {
    super(store, tableService, `customer/paginated`, translate);
  }

  @ViewChild("datatable") datatable: any;
  @ViewChild("dropdownPlaceholder") dropdownPlaceholder!: ElementRef;
  @ViewChild(MessagePortalComponent) messagePortalComponent!: MessagePortalComponent;

  editContractForm!: FormGroup;
  addEmail: string = "";
  searchText = "";
  globalContractId: number = 0;
  userRole = UserRoles;
  isLoading = false;

  override ngOnInit(): void {
    super.ngOnInit();
  }

  getColumns(): void {
    this.cols = [
      { field: "id", title: "Id", hide: true } as DatatableColumn,
      { field: "name", title: this.translate.instant("customers.name") } as DatatableColumn,
      { field: "surname", title: this.translate.instant("customers.surname") } as DatatableColumn,
      { field: "companyName", title: this.translate.instant("customers.company_name") } as DatatableColumn,
      { field: "pib", title: "PIB", sort: false } as DatatableColumn,
      { field: "mb", title: "MB", sort: false } as DatatableColumn,
      { field: "email", title: this.translate.instant("customers.email"), sort: false } as DatatableColumn,
      { field: "phone", title: this.translate.instant("customers.phone"), sort: false } as DatatableColumn,
      { field: "address", title: this.translate.instant("customers.address"), sort: false } as DatatableColumn,
      { field: "createdAt", title: this.translate.instant("users_page.created_at") } as DatatableColumn,
      { field: "updatedAt", title: this.translate.instant("blogs.updated_at") } as DatatableColumn,
      { field: "actions", title: this.translate.instant("customers.actions"), sort: false } as DatatableColumn,
    ];
  }

  deleteRow(contractId: number = 0, customerId: number) {
    Swal.fire({
      icon: "warning",
      title: this.translate.instant("customers.confirm_delete"),
      showCancelButton: true,
      confirmButtonText: this.translate.instant("blogs.yes"),
      cancelButtonText: this.translate.instant("blogs.no"),
      customClass: {
        confirmButton: "swal2-confirm btn btn-primary",
        cancelButton: "swal2-cancel btn btn-secondary",
      },
    }).then((result) => {
      if (result.isConfirmed) {
        this.loading = true;
        const deleteSub = this.contractService.deleteContract(contractId, undefined, customerId).subscribe(() => {
          deleteSub.unsubscribe();
          showMessage(PopupType.Success, this.translate.instant("customers.successfull_delete"));
          this.fetchItems(this.getPaginationParams());
        });
      }
    });
  }

  setSearchText(text: string) {
    this.search = text;
    this.cdRef.detectChanges();
  }

  onPortalAttached() {
    setTimeout(() => {
      this.positioningService.setPosition(this.dropdownPlaceholder, this.messagePortalComponent);
    }, 0);
  }
}
